import type { DonateOrg } from '../components/Donate'

import fellas4europeImg from 'url:../assets/fellas4europe.png'
import webIcon from 'url:../assets/web.png'
import facebookIcon from 'url:../assets/facebook.png'
import instagramIcon from 'url:../assets/instagram.png'
import blueskyIcon from 'url:../assets/bluesky.png'
import xIcon from 'url:../assets/x.png'

// Donation cards used on more than one page.

// Fellas4Europe: on the Help page, and on the left bank page for food relief (with a donation reference note)
export const fellas4europe: DonateOrg = {
  key: 'fellas',
  img: fellas4europeImg,
  donateUrl: 'https://fellas4europe.org/spenden/',
  socialLinks: [
    { asset: webIcon, labelKey: 'help.website', href: 'https://fellas4europe.org/' },
    {
      asset: facebookIcon,
      labelKey: 'help.facebook',
      href: 'https://www.facebook.com/p/Fellas4Europe-eV-100092421167989/',
    },
    {
      asset: instagramIcon,
      labelKey: 'help.instagram',
      href: 'https://www.instagram.com/fellas4europe/',
    },
    {
      asset: blueskyIcon,
      labelKey: 'help.bluesky',
      href: 'https://bsky.app/profile/fellas4europe.bsky.social',
    },
    { asset: xIcon, labelKey: 'help.x', href: 'https://x.com/fellas4europe' },
  ],
}
